import type { Messages } from "./types";

export const de: Messages = {
  brand: { name: "Tenqora Agent", domain: "agent.tenqora.net" },
  lang: { switchLabel: "Sprache", en: "English", de: "Deutsch" },
  common: {
    skipToContent: "Zum Inhalt springen",
    back: "Zurück",
    loading: "Laden…",
    retry: "Erneut versuchen",
    cancel: "Abbrechen",
    save: "Speichern",
    create: "Erstellen",
    delete: "Löschen",
    confirm: "Bestätigen",
    signingIn: "Anmeldung…",
    saving: "Speichern…",
    creating: "Erstellen…",
    sending: "Senden…",
    unknown: "Unbekannt",
    noDescription: "Keine Beschreibung",
    showPassword: "Passwort anzeigen",
    hidePassword: "Passwort verbergen",
    showPasswordAction: "Anzeigen",
    hidePasswordAction: "Verbergen",
    onlineRequired: "Stellen Sie die Verbindung wieder her, um Änderungen vorzunehmen.",
    pilotBanner: "Pilot · Demo-Miete ist gekennzeichnet. Live-Miete ist noch nicht verfügbar.",
    operatorBanner:
      "Operator-Bereich · Flotteninventar und freigegebene Diagnose. Für Mandanten nicht sichtbar.",
    toSite: "Website",
    privacy: "Datenschutz",
    terms: "Pilotbedingungen",
    signIn: "Anmelden",
    signOut: "Abmelden",
    register: "Registrieren",
    open: "Öffnen",
  },
  nav: {
    overview: "Übersicht",
    environment: "Umgebung",
    machines: "Macs",
    projects: "Projekte",
    tasks: "Aufgaben",
    connections: "Verbindungen",
    account: "Konto",
    operator: "Operator",
    admin: "Verwaltung",
    fleet: "Flotte",
    cabinet: "Kabinett",
    workspaceRequests: "Arbeitsbereich-Anfragen",
    primary: "Hauptnavigation",
    sections: "Bereiche",
  },
  titles: {
    home: "Tenqora Agent",
    login: "Anmelden · Tenqora Agent",
    register: "Registrieren · Tenqora Agent",
    privacy: "Datenschutz · Tenqora Agent",
    terms: "Pilotbedingungen · Tenqora Agent",
    overview: "Übersicht · Tenqora Agent",
    environment: "Umgebung · Tenqora Agent",
    environmentSave: "Speichern und Wiederherstellen · Vorschau · Tenqora Agent",
    machines: "Macs · Tenqora Agent",
    projects: "Projekte · Tenqora Agent",
    project: "Projekt · Tenqora Agent",
    workspaceRequests: "Arbeitsbereich-Anfrage · Tenqora Agent",
    tasks: "Aufgaben · Tenqora Agent",
    task: "Aufgabe · Tenqora Agent",
    lease: "Miete · Tenqora Agent",
    operation: "Vorgang · Tenqora Agent",
    connections: "Verbindungen · Tenqora Agent",
    account: "Konto · Tenqora Agent",
    operator: "Operator · Tenqora Agent",
    admin: "Verwaltung · Tenqora Agent",
    operatorWorkspaceRequests: "Arbeitsbereich-Anfragen · Operator",
    notFound: "Seite nicht gefunden · Tenqora Agent",
  },
  landing: {
    headline: "Ihr Mac.\nIhre Agents.\nEin Arbeitsbereich.",
    lead: "Ein fokussiertes Zuhause für Ihre Projekte, Aufgaben und verbundenen Werkzeuge.",
    ctaStart: "Arbeitsbereich starten",
    ctaExplore: "Arbeitsbereich erkunden",
    navSections: "Seitenabschnitte",
    navWorkflow: "Ablauf",
    navPreview: "Vorschau",
    navCapacity: "Kapazität",
    pilotNote: "Konten und Projekte sind verfügbar; Mac-Miete ist nur Demo.",
    artLabel: "Produktfotografie",
    artAlt: "Silberner Compact-Mac auf einer elfenbeinfarbenen Plinthe",
    workflowTitle: "Arbeit, geordnet.",
    workflowLead: "Projekt starten. Werkzeuge verbinden. Jeden Schritt im Blick behalten.",
    workflow1Title: "Organisieren",
    workflow1Body: "Projekte und geplante Aufgaben für Ihre Organisation zusammenhalten.",
    workflow2Title: "Verbinden",
    workflow2Body: "Anbieterverbindungen sicher speichern, wenn Sie sie nutzen möchten.",
    workflow3Title: "Fortschritt verfolgen",
    workflow3Body: "Angenommene Arbeit durch Status begleiten, bis sie endet oder stoppt.",
    previewTitle: "Alles im Blick.",
    previewLead: "Projekte, Speicher und Kontoeinstellungen — zusammen in einem Arbeitsbereich.",
    previewBadge: "Vorschau",
    previewLane1Title: "Umgebung",
    previewLane1Body: "Ihre Aktivität und Kapazitätsanfragen an einem Ort.",
    previewLane2Title: "Projekte & Aufgaben",
    previewLane2Body: "Strukturierte Arbeit mit klaren Zuständen und Ergebnissen, wenn verfügbar.",
    previewLane3Title: "Konto",
    previewLane3Body: "Profil, Sitzungen und Sprache — von Ihnen gesteuert.",
    capacityTitle: "Speicher, Archiv, Backups",
    capacityLead: "Künftige Kapazität für Ihre Organisation anfragen. Zuweisung folgt nach Prüfung.",
    capacityStorageTitle: "Projektspeicher",
    capacityStorageBody:
      "Arbeitsraum, den Sie für Projektmaterialien anfragen können. Zuweisung folgt nach Prüfung — nicht automatisch.",
    capacityArchiveTitle: "Archiv",
    capacityArchiveBody:
      "Längere Aufbewahrungskapazität, die Sie anfragen können. Speichern, Wiederherstellen und verifizierte Arbeitsbereich-Archive sind in diesem Pilot nicht verfügbar.",
    capacityBackupTitle: "Backups",
    capacityBackupBody:
      "Schutzkopie-Kapazität, die Sie für Ihren Mac-Arbeitsbereich anfragen können. Geplante Arbeitsbereich-Backups sind in diesem Pilot nicht verfügbar.",
    capacityAvailability: "Nur Anfrage · Zahlung nicht verbunden",
    bottomTitle: "Öffnen Sie Ihren Arbeitsbereich",
    bottomLead: "Erstellen Sie ein Organisationskonto und beginnen Sie mit Projekten und Aufgaben.",
    footerCopy: "© Tenqora Agent",
  },
  auth: {
    loginTitle: "Anmelden",
    loginLead: "Betreten Sie den Arbeitsbereich Ihrer Organisation.",
    registerTitle: "Konto erstellen",
    registerLead: "Starten Sie einen Arbeitsbereich für Ihre Organisation.",
    email: "E-Mail",
    password: "Passwort",
    name: "Name",
    organization: "Organisation",
    emailRequired: "E-Mail eingeben",
    passwordRequired: "Passwort eingeben",
    nameRequired: "Namen eingeben",
    orgRequired: "Organisationsnamen eingeben",
    passwordMin: "Mindestens 12 Zeichen",
    ackRequired: "Pilotbedingungen bestätigen",
    ackLabel:
      "Ich verstehe: Dies ist ein Tenqora-Agent-Pilot. Konten- und Projektdaten werden gespeichert; Mac-Miete ist nur Demo; ich habe Datenschutz und Pilotbedingungen gelesen.",
    loginAction: "Anmelden",
    registerAction: "Konto erstellen",
    noAccount: "Noch kein Konto?",
    hasAccount: "Bereits registriert?",
    loginFailed: "Anmeldung fehlgeschlagen",
    registerFailed: "Konto konnte nicht erstellt werden",
  },
  legal: {
    privacyTitle: "Datenschutz (Pilot)",
    privacyP1:
      "Im Pilot speichert Tenqora Agent Konten-, Organisations-, Projekt- und Aufgabendaten für das Kabinett. Passwörter werden als irreversible Hashes gespeichert. Sitzungen nutzen ein geschütztes HttpOnly-Cookie.",
    privacyP2:
      "Das Frontend speichert keine Passwörter, CSRF-Token oder Verbindungsgeheimnisse in localStorage. Integrationsgeheimnisse werden serverseitig verschlüsselt und nie über die API zurückgegeben. Demo-Mac-Miete gibt keine SSH-Zugangsdaten aus, legt kein Maschinenkonto an und ist kein Zugang zum physischen Verwaltungs-Mac.",
    privacyP3:
      "Öffentliche Pilotadresse: https://agent.tenqora.net. Dieser Text beschreibt das Pilotverhalten und ist keine Zusage zu einem bestimmten Gesetz, Zertifikat oder Aufbewahrungszeitraum — Fristen sind noch nicht festgelegt.",
    termsTitle: "Pilotbedingungen",
    termsP1:
      "Tenqora Agent wird als Pilot bereitgestellt. Oberfläche und API können sich ändern. Es gibt keine Tarife, Zahlungen oder kommerzielle SLA-Garantien.",
    termsP2:
      "Öffentliche Vermietung des aktuellen Verwaltungs-Macs ist nicht verfügbar. Gekennzeichnete Demo-Miete ohne SSH und ohne Maschinenkonto ist verfügbar. Live-Telemetrie und freigegebene Diagnose sind nur für Operatoren.",
    termsP3:
      "Zielmodell: Jeder Mieter erhält ein separates Standard-macOS-Konto für die Mietdauer; das Operator-Konto wird nie geteilt. Das ist eine Richtlinienanforderung, kein implementiertes MDM. Auto-Provisioning und MDM sind spätere Stufen nach Prüfung der Voraussetzungen.",
    termsP4:
      "Plan-Aufgaben erzeugen eine deterministische Checkliste und sind keine LLM-Generierung. Gespeicherte Anbieter-Schlüssel sind noch nicht mit KI-Aufgaben verbunden. Nutzer erhalten keine beliebige Shell, PDU, MCP-Server oder Infrastrukturverwaltung.",
    termsP5: "In diesem Pilot wird keine verkaufende Rechtsperson und kein kommerzielles Angebot erklärt.",
  },
  notFound: {
    code: "404",
    title: "Seite nicht gefunden",
    body: "Diese Adresse existiert nicht oder die Ressource ist in Ihrem Kontext nicht verfügbar. Wir bestätigen nicht, ob Objekte anderer Mandanten existieren.",
    home: "Zur Startseite",
  },
  states: {
    sessionEnded: "Sitzung beendet",
    sessionEndedBody: "Melden Sie sich erneut an, um fortzufahren.",
    forbidden: "Nicht erlaubt",
    forbiddenBody: "Sie haben keine Berechtigung für diese Aktion.",
    offline: "Offline",
    offlineBody: "Änderungen sind bis zur Wiederverbindung deaktiviert. Geheimnisse werden nie zwischengespeichert.",
    error: "Etwas ist schiefgelaufen",
    empty: "Noch nichts vorhanden",
    loadFailed: "Laden fehlgeschlagen",
  },
  api: {
    invalidJson: "Der Server hat eine unerwartete Antwort geliefert. Bitte später erneut versuchen.",
    sessionExpired: "Sitzung beendet. Bitte erneut anmelden.",
    forbidden: "Keine Berechtigung für diese Aktion.",
    offline: "Offline. Änderungen sind nicht verfügbar.",
    network: "Netzwerk nicht verfügbar. Bitte später erneut versuchen.",
    httpError: "Anfrage fehlgeschlagen ({status}).",
  },
  dashboard: {
    title: "Übersicht",
    lead: "Ihre Projekte, Aufgaben und aktiven Demo-Mieten.",
    projects: "Projekte",
    tasks: "Aufgaben",
    activeLeases: "Aktive Demo-Mieten",
    recentTasks: "Aktuelle Aufgaben",
    recentStates: "Zustände der geladenen Aufgaben",
    recentStatesNote: "Nur die Liste unten. Keine vollständige Historie.",
    noTasks: "Noch keine Aufgaben",
    noTasksBody: "Öffnen Sie ein Projekt, um eine geplante Aufgabe zu erstellen und den Fortschritt zu verfolgen.",
    noProjects: "Noch keine Projekte",
    noProjectsBody: "Erstellen Sie ein Projekt, um Arbeit für Ihre Organisation zu organisieren.",
    openProjects: "Zu Projekten",
  },
  machines: {
    title: "Demo-Miete",
    lead: "Gekennzeichnete Demo-Miete für Ihre Organisation. Live-Miete ist in diesem Pilot nicht verfügbar.",
    empty: "Keine Demo-Maschinen",
    emptyBody: "Derzeit sind keine Demo-Mietoptionen in Ihrer Organisation verfügbar.",
    demoName: "Demo-Mac-Studio",
    requestDemo: "Demo-Miete anfordern",
    endLease: "Miete beenden",
    leaseCard: "Mietdetails",
    requestTitle: "Demo-Miete anfordern",
    requestConfirm: "Anfordern",
    requestBody:
      "Annahme bedeutet keinen fertigen Mac. Kein SSH und kein Maschinenkonto. Ein Reservierungskonflikt führt zu einem Fehler.",
    endTitle: "Miete beenden",
    endConfirm: "Miete beenden",
    endBody: "Der Widerruf wird asynchron angefordert. Die Trennung gilt erst nach Abschluss auf dem Server.",
    endAck: "Ich verstehe: Die Trennung wird erst nach Abschluss auf dem Server bestätigt.",
    modelUnknown: "Modell unbekannt",
    leasePrefix: "Miete",
    mode: "Modus",
    lastSeen: "zuletzt gesehen",
  },
  leases: {
    title: "Miete",
    back: "Maschinen",
    noSsh: "Kein SSH · Demo legt kein Mac-Konto an",
    endingTitle: "Beendigung läuft",
    endingBody: "Widerruf noch nicht bestätigt. Trennung ist nie sofort.",
    endAction: "Miete beenden",
    endTitle: "Demo-Miete beenden",
    endBody: "Läuft asynchron. Zugang gilt erst nach Serverbestätigung als widerrufen.",
    endAck: "Ich verstehe: Bestätigung kommt nur vom Server.",
    notFound: "Miete nicht gefunden",
  },
  projects: {
    title: "Projekte",
    lead: "Organisieren Sie Ihre Arbeit und behalten Sie den nächsten Schritt klar im Blick.",
    newTitle: "Neues Projekt",
    name: "Name",
    description: "Beschreibung",
    nameRequired: "Projektnamen eingeben",
    createFailed: "Projekt konnte nicht erstellt werden",
    empty: "Keine Projekte",
    emptyBody: "Erstellen Sie oben Ihr erstes Projekt.",
    detailLead: "Erstellen Sie eine Plan-Aufgabe für eine strukturierte Checkliste. Diagnose erfordert die Operator-Rolle.",
    newTask: "Neue Aufgabe",
    taskTitle: "Titel",
    instructions: "Anweisungen",
    kind: "Art",
    kindPlan: "Plan-Checkliste",
    kindDiagnostics: "Diagnose (Operator)",
    titleRequired: "Titel eingeben",
    instructionsRequired: "Anweisungen eingeben",
    diagnosticsOnlyOperator: "Diagnose ist nur für Operatoren verfügbar",
    createTask: "Aufgabe erstellen",
    createTaskFailed: "Aufgabe konnte nicht erstellt werden",
    connectionsTitle: "Projektverbindungen",
    connectionsLead:
      "Hängen Sie gespeicherte Verbindungen Ihrer Organisation an dieses Projekt. Trennen entfernt nur die Bindung.",
    connectionsEmpty: "Keine Verbindungen angehängt",
    connectionsEmptyBody: "Hängen Sie unten eine gespeicherte Verbindung an oder legen Sie eine unter Verbindungen an.",
    connectionsFailed: "Projektverbindungen konnten nicht geladen werden",
    retryConnections: "Erneut versuchen",
    availableFailed: "Verfügbare Verbindungen konnten nicht geladen werden",
    retryAvailable: "Erneut versuchen",
    capChecklist: "Eingebaute Nicht-KI-Checkliste",
    capAi: "KI-Ausführung",
    capRepo: "Repository-Ausführung",
    capAvailable: "verfügbar",
    capUnavailable: "nicht verfügbar",
    verificationNote:
      "Prüfung ist ein zeitpunktbezogener schreibgeschützter Credential-Check. Sie belegt keine Anbieterrechte, Scopes oder Budgets.",
    attachTitle: "Verbindung anhängen",
    attachSelect: "Gespeicherte Verbindung",
    attachPlaceholder: "Verbindung wählen",
    attachNone: "Keine Verbindungen mehr zum Anhängen",
    attachNeedConnections: "Legen Sie zuerst unter Verbindungen eine Verbindung an.",
    attachAllBound: "Alle gespeicherten Verbindungen sind bereits angehängt.",
    attach: "Anhängen",
    attaching: "Anhängen…",
    attachFailed: "Verbindung konnte nicht angehängt werden",
    manageConnections: "Verbindungen verwalten",
    detach: "Trennen",
    detachTitle: "Verbindung trennen",
    detachBody:
      "Entfernt die Verbindung nur vom Projekt. Der verschlüsselte Schlüssel bleibt unter Verbindungen und wird beim Anbieter nicht widerrufen.",
    detachConfirm: "Trennen",
    detachFailed: "Trennen fehlgeschlagen",
    setupTitle: "Projekteinrichtung",
    setupLead:
      "Für interaktive Mac-Arbeit, iOS-Builds oder Agenten: zuerst Zugangsdaten hier vorbereiten. Live-Mac-Provisioning und Agent-Ausführung sind in diesem Pilot nicht verfügbar.",
    setupConnections: "Projektverbindungen angehängt",
    setupConnectionsReady: "{count} gespeicherte Verbindung(en) an dieses Projekt angehängt.",
    setupConnectionsNeeded: "Hängen Sie unten eine gespeicherte Verbindung an oder legen Sie eine unter Verbindungen an.",
    setupVerification: "Prüfaktualität",
    setupVerificationNone: "Noch keine angehängten Verbindungen zum Prüfen.",
    setupVerificationSummary:
      "geprüft {verified} · veraltet {stale} · fehlgeschlagen {failed} · nicht geprüft {not_checked}. Nur zeitpunktbezogen — keine Anbieter-Scopes oder Budgets.",
    setupChecklistTask: "Plan-Checklisten-Aufgaben",
    setupChecklistReady: "Jetzt verfügbar: unten eine deterministische Plan-Checklisten-Aufgabe erstellen.",
    setupChecklistUnavailable: "Checklisten-Aufgaben sind für dieses Projekt nicht als verfügbar gemeldet.",
    setupAi: "KI- / Agent-Ausführung",
    setupAiUnavailable: "Nicht verfügbar. Angehängte Schlüssel starten keine Agentenläufe auf einem Mac.",
    setupRepo: "Repository-Ausführung",
    setupRepoUnavailable: "Nicht verfügbar. Kein CI-Runner und keine Repository-Job-Ausführung in diesem Pilot.",
    setupMac: "Live-Mac-Provisioning",
    setupMacUnavailable:
      "Nicht verfügbar. Keine automatische Mieter-Mac-Zuweisung, kein Remote-Desktop-Gateway und keine SSH-Kontoausstellung.",
    setupDemoHint: "Sie können nur gekennzeichnete Demo-Miete erkunden — kein SSH und kein Maschinenkonto.",
    setupDemoLink: "Demo-Miete öffnen",
    setupCreateTask: "Checklisten-Aufgabe erstellen",
    setupNextSteps:
      "Als Nächstes: Verbindungen anhängen und prüfen, bei Bedarf eine Arbeitsbereich-Anfrage stellen, eine Plan-Checkliste erstellen und Demo-Miete nur als gekennzeichnete Vorschau nutzen. Noch kein Live-Provisioning.",
    workspaceRequestLink: "Arbeitsbereich anfragen",
    activityTitle: "Projektaktivität",
    activityLead:
      "Aufgaben- und Mac-Anfrage-Zähler für dieses Projekt aus der Aufgabendatenbank. Kein HTTP-Verkehr, keine Verfügbarkeit und keine Live-Mac-Telemetrie.",
    activityWindow: "Zeitraum",
    activityWindow24h: "Letzte 24 Stunden (UTC)",
    activityWindow7d: "Letzte 7 Tage (UTC)",
    activityObserved: "Beobachtet {when}",
    activitySource: "Quelle: Aufgabendatenbank",
    activityFailed: "Projektaktivität konnte nicht geladen werden",
    activityRetry: "Erneut versuchen",
    activityRefresh: "Aktualisieren",
    activityRefreshing: "Aktualisieren…",
    activityTableToggle: "Aktivitätstabelle anzeigen (UTC-Abschnitte)",
    activityScaleMax: "Diagrammskala max. {max}",
    activityUtcNote: "Abschnittszeiten sind UTC",
    activityTaskCounts: "Aktuelle Aufgabenstatus",
    activityTotal: "Aufgaben gesamt",
    activityMacRequests: "Mac-Arbeitsbereich-Anfragen",
    activitySeriesTitle: "Aufgabenaktivität im Zeitverlauf",
    activitySeriesLead:
      "Erstellt zählt neue Aufgaben. Erfolgreich und Fehlgeschlagen zählen gespeicherte Statusübergänge. Der letzte Abschnitt kann unvollständig sein.",
    activityCreated: "Erstellt",
    activitySucceeded: "Erfolgreich",
    activityFailedEvents: "Fehlgeschlagen",
    activityChartSummary:
      "{window}: {created} erstellt, {succeeded} erfolgreich, {failed} fehlgeschlagen im Zeitraum.",
    activityTableCaption: "Aufgabenaktivität nach Zeitabschnitt",
    activityBucket: "Abschnitt (UTC)",
    activityCapsNote:
      "Anwendungsmetriken und Archiv/Wiederherstellung sind für dieses Projekt nicht verfügbar. Fehlende Fähigkeiten werden nicht als Null dargestellt.",
    activityRecent: "Aktuelle Aufgaben",
    activityRecentEmpty: "Keine aktuellen Aufgaben",
    servicesTitle: "Anwendungen",
    servicesLead:
      "Überwachte Anwendungen in diesem Projekt. Die Probe-Dauer ist ein synthetischer HTTP-Check — kein Kundenverkehr und keine Latenzperzentile.",
    servicesSource: "Quelle: Kubernetes-Probe",
    servicesSourceProbe: "Kubernetes-Probe",
    servicesObserved: "Liste beobachtet {when}",
    servicesRefresh: "Aktualisieren",
    servicesRefreshing: "Aktualisieren…",
    servicesRetry: "Erneut versuchen",
    servicesFailed: "Anwendungen konnten nicht geladen werden",
    servicesEmpty: "Keine überwachten Anwendungen",
    servicesEmptyBody:
      "Für dieses Projekt ist noch keine Anwendung zur Überwachung verbunden. Das ist keine Provisionierungs- oder Deployment-Steuerung.",
    servicesCapsNote:
      "Deployment-Steuerung und HTTP-Verkehrsmetriken sind nicht verfügbar. Fehlende Signale bleiben unbekannt — sie werden nicht als Null gezeigt.",
    servicesUnknown: "unbekannt",
    servicesLastObserved: "Letztes Sample",
    servicesReplicas: "Replicas bereit / gewünscht",
    servicesReplicasValue: "{ready} / {desired}",
    servicesProbeResult: "Probe-Ergebnis",
    servicesProbeOk: "erfolgreich",
    servicesProbeFail: "fehlgeschlagen",
    servicesProbeDuration: "Probe-Dauer",
    servicesProbeNote:
      "Die Dauer stammt nur von einer synthetischen Collector-Probe. Keine echte Nutzerlatenz und kein Anfragevolumen.",
    servicesCollectionOk: "erfasst",
    servicesCollectionUnavailable: "Collector nicht verfügbar",
    servicesNoSamples: "Noch keine Samples für diese Anwendung.",
    servicesChartTitle: "Probe-Dauer-Samples",
    servicesScaleMax: "Diagrammskala max. {max} ms",
    servicesChartSummary: "{count} Samples · Skala max. {max} ms",
    servicesChartRange: "Samples {from} – {to} UTC",
    servicesTableToggle: "Sample-Tabelle anzeigen (UTC)",
    servicesTableCaption: "Anwendungs-Probe-Samples",
    servicesColWhen: "Beobachtet (UTC)",
    servicesColCollection: "Erfassung",
    servicesReleasesTitle: "Release-Beobachtungen",
    servicesReleasesLead:
      "Beobachtete Kubernetes-Rollout-Zustände für diese Anwendung. Keine Deploy-Befehle und kein Nachweis von Nutzerverkehr.",
    servicesReleasesEmpty: "Noch keine Release-Beobachtungen.",
    servicesReleaseRevision: "Revision {revision}",
    servicesReleaseProgressing: "läuft",
    servicesReleaseAvailable: "bereit",
    servicesReleaseFailed: "fehlgeschlagen",
    alertsTitle: "Benachrichtigungen",
    alertsLead:
      "In-App-Vorfälle aus beobachteter Anwendungsgesundheit für dieses Projekt. Die Auswertung läuft nur, wenn Sie sie hier aktivieren.",
    alertsChannelReported:
      "Die Sitzung meldet E-Mail-Zustellung. Diese Seite sendet keine E-Mail und keinen Push.",
    alertsChannelNote:
      "Zustellung nur in der App. E-Mail- und Push-Benachrichtigungen sind nicht konfiguriert.",
    alertsObserved: "Liste beobachtet {when}",
    alertsRefresh: "Aktualisieren",
    alertsRefreshing: "Aktualisieren…",
    alertsRetry: "Erneut versuchen",
    alertsFailed: "Benachrichtigungen konnten nicht geladen werden",
    alertsEmpty: "Keine Vorfälle",
    alertsEmptyBody:
      "Keine offenen oder kürzlichen Vorfälle für überwachte Anwendungen in diesem Projekt.",
    alertsDisabledNote:
      "In-App-Überwachung ist aus. Neue Vorfälle werden nicht ausgewertet. Vorhandene Historie bleibt sichtbar und wird nicht als behoben markiert.",
    alertsEnabledLabel: "In-App-Überwachung an",
    alertsDisabledLabel: "In-App-Überwachung aus",
    alertsEnable: "In-App-Überwachung aktivieren",
    alertsDisable: "In-App-Überwachung deaktivieren",
    alertsPrefFailed: "Benachrichtigungseinstellung konnte nicht aktualisiert werden",
    alertsReason: "Grund",
    alertsReasonDegraded: "beeinträchtigt",
    alertsReasonUnavailable: "nicht verfügbar",
    alertsReasonStale: "veraltet",
    alertsStatusOpen: "offen",
    alertsStatusResolved: "behoben",
    alertsOpened: "Eröffnet {when}",
    alertsResolved: "Behoben {when}",
    alertsAcknowledged: "Zur Kenntnis genommen {when}",
    alertsAcknowledge: "Zur Kenntnis nehmen",
    alertsAcknowledging: "Wird gespeichert…",
    alertsAckFailed: "Vorfall konnte nicht zur Kenntnis genommen werden",
    alertsAckNote:
      "Zur Kenntnis nehmen bestätigt nur, dass Sie den Vorfall gesehen haben. Es bedeutet nicht, dass die Anwendung wiederhergestellt ist.",
  },
  workspace: {
    title: "Arbeitsbereich-Anfrage",
    lead: "Teilen Sie mit, welchen Mac-Arbeitsbereich Sie für dieses Projekt benötigen. Ein Operator prüft Ihre Anfrage. Es entstehen noch keine Kosten, und es wird noch keine Maschine zugewiesen.",
    bounds:
      "Das sind angeforderte Anforderungen zur Prüfung. Sie können nicht verfügbar sein, und das Absenden reserviert oder startet keinen Arbeitsbereich.",
    newTitle: "Neue Anfrage",
    profile: "Geplante Nutzung",
    profileRequired: "Nutzungsprofil wählen",
    toolsLabel: "Angeforderte Werkzeuge",
    memory: "Angeforderter Speicher (RAM)",
    memoryHint: "Wie viel Speicher Sie anfragen — vorbehaltlich Prüfung.",
    memoryOption: "{gb} GB angefordert",
    memoryRequired: "Angeforderten Speicher wählen",
    storage: "Angeforderter Speicherplatz (GB)",
    storageHint: "Wie viel Speicherplatz Sie anfragen — vorbehaltlich Prüfung.",
    storageRange: "Speicherplatz zwischen 128 und 4096 GB eingeben",
    duration: "Angeforderte Dauer (Tage)",
    durationHint: "Wie lange Sie den Arbeitsbereich behalten möchten — vorbehaltlich Prüfung.",
    durationRange: "Dauer zwischen 1 und 30 Tagen eingeben",
    notes: "Notizen",
    notesHint: "Optionaler Kontext zur Prüfung. Keine Passwörter oder API-Schlüssel angeben.",
    notesMax: "Notizen dürfen höchstens 2000 Zeichen haben",
    submit: "Anfrage senden",
    submitFailed: "Arbeitsbereich-Anfrage konnte nicht gesendet werden",
    conflictActive:
      "Dieses Projekt hat bereits eine aktive Arbeitsbereich-Anfrage, oder die Anfrage hat sich geändert. Liste neu geladen — prüfen Sie sie vor dem nächsten Versuch.",
    listTitle: "Anfrageverlauf",
    empty: "Noch keine Arbeitsbereich-Anfragen",
    emptyBody:
      "Senden Sie oben eine Anfrage, wenn Sie bereit sind. Sie wird geprüft; über dieses Formular wird nichts zugewiesen.",
    loadFailed: "Arbeitsbereich-Anfragen konnten nicht geladen werden",
    retry: "Erneut versuchen",
    summary: "{memory} GB RAM · {storage} GB Speicher · {days} Tage",
    reviewNoteLabel: "Operator-Notiz (für Sie sichtbar)",
    cancel: "Anfrage abbrechen",
    cancelTitle: "Arbeitsbereich-Anfrage abbrechen",
    cancelBody: "Bricht nur diese Anfrage ab. Ihre übrigen Projektdaten bleiben unverändert.",
    cancelConfirm: "Anfrage abbrechen",
    cancelFailed: "Anfrage konnte nicht abgebrochen werden",
    cancelConflict:
      "Diese Anfrage hat sich geändert. Liste neu geladen — erneut versuchen, falls sie noch aktiv ist.",
    pageStatus: "Seite {page} von {pages} · {total} Anfragen",
    prevPage: "Zurück",
    nextPage: "Weiter",
    planShow: "Plan anzeigen",
    planHide: "Plan ausblenden",
    planTitle: "Anfrageplan",
    planMode:
      "Nur Planung. Diese Ansicht zeigt den Serverplan für die Anfrage — sie startet keine Arbeit.",
    planNoExecution:
      "Kein Ausführen-Steuerelement. Der Plan ist nicht ausführbar: Von diesem Bildschirm aus wird nichts reserviert, provisioniert oder auf einem Mac ausgeführt.",
    planLoadFailed: "Anfrageplan konnte nicht geladen werden",
    planRetry: "Erneut versuchen",
    planSourceLabel: "Planquelle",
    planSourcePersisted: "Gespeicherter Snapshot mit der Anfrage",
    planSourcePreview: "Vorschau für ältere Anfragen — kein gespeicherter Snapshot",
    planSnapshotAt: "gespeichert {when}",
    planRequestState: "Anfragestatus",
    planPrerequisites: "Voraussetzungen (nicht erfüllt)",
    planPrerequisitesNone: "Keine Voraussetzungs-Blocker aufgeführt.",
    planSteps: "Geplante Schritte",
    planStepsNone: "Keine Schritte aufgeführt.",
    planCapabilities: "Fähigkeiten",
    planCapProvisioning: "Bereitstellung",
    planCapAiExecution: "KI-Ausführung",
    planCapArchiveRestore: "Archiv-Wiederherstellung",
    planCapDisabled: "deaktiviert",
    planExecutableLabel: "Ausführbar",
    planExecutableNo: "nein",
    planModeLabel: "Modus",
  },
  tasks: {
    title: "Aufgaben",
    lead: "Verfolgen Sie Ihre Arbeit von der Warteschlange bis zum Ergebnis.",
    empty: "Noch keine Aufgaben",
    emptyBody: "Erstellen Sie eine Aufgabe in einem Projekt, um Arbeit zu verfolgen.",
    noResults: "Keine passenden Aufgaben",
    noResultsBody: "Andere Suche versuchen oder Filter zurücksetzen.",
    searchLabel: "Suche",
    searchPlaceholder: "Nach Titel suchen",
    stateLabel: "Status",
    stateAll: "Alle Status",
    projectLabel: "Projekt",
    projectAll: "Alle Projekte",
    applyFilters: "Anwenden",
    refresh: "Aktualisieren",
    refreshing: "Aktualisieren…",
    refreshStale: "Aktualisierung fehlgeschlagen",
    refreshFailed: "Aufgaben konnten nicht aktualisiert werden",
    retryRefresh: "Erneut versuchen",
    loadFailed: "Aufgaben konnten nicht geladen werden",
    projectsFailed: "Projekte konnten nicht geladen werden",
    backToFirstPage: "Zur ersten Seite",
    createViaProjects: "Aufgabe in einem Projekt erstellen",
    openProject: "Projekt öffnen",
    pageStatus: "Seite {page} von {pages} · {total} Aufgaben",
    prevPage: "Zurück",
    nextPage: "Weiter",
    back: "Aufgaben",
    instructions: "Anweisungen",
    result: "Ergebnis",
    noResult: "Noch kein Ergebnis — warten Sie auf den Abschluss des Vorgangs.",
    timelineTitle: "Fortschritt",
    timelineScope: "Verlauf seit Aktivierung der Nachverfolgung. Ältere Aufgaben können frühere Schritte fehlen.",
    timelineEmpty: "Noch keine Fortschrittsereignisse für diese Aufgabe.",
    cancel: "Aufgabe abbrechen",
    cancelling: "Abbrechen…",
    cancelRequested: "Abbruch angefordert",
    cancelFailed: "Aufgabe konnte nicht abgebrochen werden",
    notFound: "Aufgabe nicht gefunden",
  },
  checklist: {
    heading: "Strukturierte Checkliste",
    engineNote: "Eingebaute Checkliste · nicht KI-generiert",
    summary: "Eine strukturierte Projekt-Checkliste. Es wurde kein externes KI-Modell verwendet.",
    stepLabel: "Schritt {n}",
    diagnosticsHeading: "Diagnose-Momentaufnahme",
    diagnosticsNote: "Freigegebene schreibgeschützte Beobachtung vom Operator-Mac.",
    fieldCpu: "CPU",
    fieldMem: "Speicher",
    fieldDisk: "Festplatte",
    fieldUptime: "Laufzeit",
    otherFields: "Weitere Felder",
  },
  checklistSteps: [
    {
      title: "Ergebnis definieren",
      detail: "Halten Sie das Ziel in eigenen Worten fest.",
    },
    {
      title: "Separaten Arbeitszweig vorbereiten",
      detail: "Repository-Zugang prüfen und Geheimnisse aus Quelldateien fernhalten.",
    },
    {
      title: "Umsetzen und prüfen",
      detail: "Arbeit in kleine Änderungen teilen, dann Tests und Build ausführen.",
    },
    {
      title: "Prüfen und freigeben",
      detail: "Ergebnis prüfen, bevor es in einer separaten Umgebung bereitgestellt wird.",
    },
  ],
  operations: {
    title: "Vorgang",
    lead: "Ihre Anfrage wird bearbeitet. Diese Seite aktualisiert sich mit dem Fortschritt.",
    back: "Übersicht",
    runningTitle: "Läuft…",
    runningBody: "Status wird aktualisiert, bis der Vorgang endet. Erfolg erscheint erst nach Serverbestätigung.",
    failedTitle: "Vorgang fehlgeschlagen",
    canceledTitle: "Vorgang abgebrochen",
    failedBody: "Der Server meldete ein erfolgloses Ergebnis.",
    succeededTitle: "Vorgang bestätigt",
    succeededBody: "Der Server hat den erfolgreichen Abschluss festgehalten.",
    pollError: "Statusaktualisierung fehlgeschlagen",
    openLease: "Miete öffnen",
    openTask: "Aufgabe öffnen",
    noResource: "Objekt noch nicht zugewiesen",
    unknownResource: "Objekt kann noch nicht geöffnet werden",
    toMachines: "Zu den Maschinen",
    objectLabel: "Objekt",
    waitingObject: "noch nicht zugewiesen",
    opLabel: "Vorgang",
  },
  account: {
    title: "Konto",
    organization: "Organisation",
    capabilities: "Funktionen",
    profileTitle: "Profil",
    profileLead: "Anzeigenamen aktualisieren. Organisationsumbenennung nur für Inhaber und Admins. E-Mail und Rolle sind hier nicht änderbar.",
    name: "Name",
    orgRenameHint: "Inhaber und Admins können die Organisation umbenennen.",
    orgRenameForbidden: "Nur Inhaber und Admins können die Organisation umbenennen.",
    nameRequired: "Namen eingeben (2–100 Zeichen)",
    orgRequired: "Organisationsnamen eingeben (2–100 Zeichen)",
    profileSaved: "Profil gespeichert.",
    profileFailed: "Profil konnte nicht gespeichert werden",
    saveProfile: "Profil speichern",
    emailReadonly: "E-Mail (nur Lesen)",
    roleReadonly: "Rolle (nur Lesen)",
    changePassword: "Passwort ändern",
    currentPassword: "Aktuelles Passwort",
    newPassword: "Neues Passwort",
    currentRequired: "Aktuelles Passwort eingeben",
    newMin: "Neues Passwort mindestens 12 Zeichen",
    changed: "Passwort geändert. Andere Sitzungen wurden ungültig.",
    changeFailed: "Passwort konnte nicht geändert werden",
    sessionsTitle: "Sitzungen",
    sessionsLead: "Aktive Anmeldungen Ihres Kontos. Andere Geräte können widerrufen werden; diese Sitzung bleibt angemeldet, bis Sie sich abmelden.",
    sessionCurrent: "Dieses Gerät",
    sessionExpires: "Läuft ab",
    sessionCreated: "Erstellt",
    revokeSession: "Widerrufen",
    revokeOthers: "Andere Sitzungen widerrufen",
    revokeOthersTitle: "Andere Sitzungen widerrufen?",
    revokeOthersBody: "Alle anderen Anmeldungen werden beendet. Dieses Gerät bleibt angemeldet.",
    revokeOthersConfirm: "Andere widerrufen",
    revokeConfirmTitle: "Diese Sitzung widerrufen?",
    revokeConfirmBody: "Dieses Gerät muss sich erneut anmelden.",
    sessionsEmpty: "Keine Sitzungen aufgeführt.",
    sessionsFailed: "Sitzungen konnten nicht geladen werden",
    revokeFailed: "Sitzung konnte nicht widerrufen werden",
    revokedCount: "{n} Sitzung(en) widerrufen.",
    audit: "Organisationsaudit",
    auditEmpty: "Noch keine Einträge.",
    auditUnavailable: "Audit nicht verfügbar",
    auditUnknown: "Kontoaktivität",
    auditActions: {
      "account.login": "Angemeldet",
      "account.profile_updated": "Profil aktualisiert",
      "account.password_changed": "Passwort geändert",
      "account.session_revoked": "Sitzung widerrufen",
      "account.other_sessions_revoked": "Andere Sitzungen widerrufen",
      "account.registered": "Konto erstellt",
      "project.created": "Projekt erstellt",
      "task.created": "Aufgabe erstellt",
      "task.cancel_requested": "Aufgabenabbruch angefordert",
      "demo.lease_requested": "Demo-Miete angefordert",
      "demo.lease_end_requested": "Beenden der Demo-Miete angefordert",
      "storage.requested": "Kapazitätsanfrage gesendet",
      "storage.request_canceled": "Kapazitätsanfrage abgebrochen",
      "integration.created": "Verbindung gespeichert",
      "integration.deleted": "Verbindung gelöscht",
      "integration.verified": "Verbindung geprüft",
      "machine.maintenance_enabled": "Wartung aktiviert",
      "machine.maintenance_disabled": "Wartung beendet",
    },
    roles: {
      owner: "Inhaber",
      admin: "Admin",
      developer: "Entwickler",
      viewer: "Betrachter",
      operator: "Operator",
    },
    roleUnknown: "Mitglied",
    connections: "Verbindungen",
    connectionsLead: "Auf schmalen Bildschirmen öffnen Sie Verbindungen hier. Schlüssel sind verschlüsselt; gespeichert ist nicht geprüft.",
    openConnections: "Verbindungen öffnen",
    openEnvironment: "Umgebung öffnen",
    pilotMeta: "Pilotmodus · agent.tenqora.net",
  },
  environment: {
    title: "Ihre Umgebung",
    lead: "Ihre Projekte, Aufgaben und Kapazitätsanfragen an einem Ort",
    activityTitle: "Ihre Aktivität",
    projects: "Projekte",
    queued: "Aufgaben in Warteschlange",
    running: "Laufende Aufgaben",
    completed: "Abgeschlossene Aufgaben",
    connections: "Verbindungen",
    demoLeases: "Demo-Mieten",
    demoLeasesHint: "Nur gekennzeichnete DEMO-Mietvorschau.",
    resourcesTitle: "Live-Speicher & Archive",
    resourcesEmpty:
      "Noch nichts verbunden. Eine Kapazitätsanfrage weist Speicher, Archiv oder Backup nicht von selbst zu.",
    resourcesEmptyProvisioning:
      "Speicherzuweisung wird gemeldet, und es wurden keine Ressourcendatensätze zurückgegeben.",
    resourceIntro:
      "{n} Datensatz/Datensätze zurückgegeben. Ein Datensatz ist kein geprüftes Archiv und keine Zuweisung.",
    resourceUndescribed: "Dieser Datensatz hat keine Felder, die das Kabinett anzeigen darf.",
    storageProvisioningOn:
      "Speicherzuweisung wird gemeldet. Speichern, Wiederherstellen, Export und Löschen sind hier nicht verbunden.",
    liveComputeOff:
      "Laufende Ausführung ist nicht verbunden. Die Zahlen oben sind Einträge in diesem Konto.",
    archiveRestoreNote:
      "Arbeitsbereich speichern, wiederherstellen und verifizierte Archive sind in diesem Pilot nicht verfügbar.",
    catalogTitle: "Kapazitätsanfragen",
    catalogLead: "Eine Anfrage bleibt zur Prüfung. Sie weist keinen Speicher zu.",
    paymentNotConnected: "Zahlung nicht verbunden",
    productStorage: "Projektspeicher",
    productArchive: "Archiv",
    productBackup: "Backup",
    unitGb: "GB",
    availabilityRequest: "Nur Anfrage",
    requestTitle: "Neue Kapazitätsanfrage",
    product: "Kapazitätstyp",
    amount: "Menge (GB)",
    amountHint: "Ganzzahl von 1 bis 100000",
    amountRequired: "Menge in GB eingeben",
    amountRange: "Ganzzahl von 1 bis 100000 eingeben",
    notes: "Notizen (optional)",
    notesHint: "Bis 2000 Zeichen",
    submit: "Anfrage senden",
    submitting: "Senden…",
    submitFailed: "Anfrage konnte nicht gesendet werden",
    conflict: "Diese Anfrage widerspricht einer früheren Übermittlung. Details ändern oder warten.",
    historyTitle: "Ihre Anfragen",
    requestStates: "Zustände der geladenen Anfragen",
    requestStatesNote: "Nur die Liste unten. Eine Anfrage ist kein Speicher, kein Sichern und keine Zahlung.",
    historyEmpty: "Noch keine Kapazitätsanfragen.",
    cancel: "Anfrage abbrechen",
    cancelTitle: "Diese Anfrage abbrechen?",
    cancelBody: "Die Anfrage wird als abgebrochen markiert. Es wurde nichts gekauft oder zugewiesen.",
    cancelConfirm: "Anfrage abbrechen",
    cancelFailed: "Anfrage konnte nicht abgebrochen werden",
    stateRequested: "angefordert",
    stateCanceled: "abgebrochen",
  },
  integrations: {
    title: "Verbindungen",
    lead: "Anbieter-Zugangsdaten verschlüsselt für Ihre Organisation speichern. Gespeichert ist nicht geprüft. Prüfungen sind schreibgeschützt.",
    newTitle: "Neue Verbindung",
    name: "Name",
    provider: "Anbieter",
    secret: "Geheimnis / API-Schlüssel",
    secretHint: "Maskierte Eingabe. Nicht in localStorage oder Client-Logs.",
    nameRequired: "Namen eingeben",
    secretMin: "Mindestens 8 Zeichen",
    secretMax: "Maximal 8192 Zeichen",
    save: "Verschlüsselt speichern",
    saveFailed: "Verbindung konnte nicht gespeichert werden",
    boundsTitle: "Ehrliche Pilotgrenzen",
    bound1: "Keine simulierte LLM und kein magischer Mac-Zugang über diese Schlüssel.",
    bound2: "Keine beliebigen MCP-Server oder SSH-Formulare — nur gelistete Anbieter.",
    bound3: "Auto-Provisioning und MDM sind nicht implementiert; Ziel ist ein separates Standard-Mieterkonto.",
    bound4: "Schlüssel mit minimalen Rechten nutzen; Verbrauch abrechnet der Anbieter.",
    empty: "Noch keine Verbindungen.",
    verify: "Prüfen",
    verifying: "Prüfen…",
    delete: "Löschen",
    deleteTitle: "Verbindung löschen",
    deleteBody: "Entfernt nur den verschlüsselten Eintrag in Tenqora Agent. Der Schlüssel wird beim Anbieter nicht widerrufen.",
    deleteAck: "Ich verstehe, dass ich den Schlüssel beim Anbieter noch widerrufen muss.",
    deleteConfirm: "Eintrag löschen",
    deleteUnexpected: "Unerwartete Löschantwort vom Server.",
    deleteFailed: "Löschen fehlgeschlagen",
    verifyFailed: "Prüfung fehlgeschlagen",
    lastChecked: "zuletzt geprüft",
    rotate: "Schlüssel rotieren",
    rotating: "Rotieren…",
    rotateSave: "Neuen Schlüssel speichern",
    rotateHint:
      "Ersetzt das verschlüsselte Geheimnis und setzt den Status auf gespeichert. Nutzt die aktuelle Version als Konfliktwächter.",
    newSecret: "Neues Geheimnis / API-Schlüssel",
    rotateFailed: "Schlüssel konnte nicht rotiert werden",
    rotateConflict:
      "Diese Verbindung wurde woanders geändert. Neueste Version geladen — bitte erneut versuchen.",
  },
  operator: {
    title: "Flottenübersicht",
    lead: "Operator-Ansicht der Software-Verfügbarkeit. Kein Host-Shutdown und keine freie Shell.",
    users: "Benutzer",
    tenants: "Organisationen",
    tasks: "Aufgaben",
    machines: "Maschinen",
    events: "Aktuelle Ereignisse",
    noEvents: "Keine aktuellen Ereignisse.",
    maintenanceOn: "Wartung aktivieren",
    maintenanceOff: "Wartung beenden",
    reason: "Grund",
    reasonRequired: "Grund eingeben (mindestens 8 Zeichen)",
    confirmTitle: "Wartung ändern",
    confirmBody: "Ändert nur die Software-Verfügbarkeit. Host-Shutdown und freie Befehle sind nicht verfügbar.",
    confirmAction: "Anwenden",
    actionFailed: "Wartung konnte nicht aktualisiert werden",
    serial: "Serie",
  },
  admin: {
    title: "Plattformadministrator",
    lead: "Die Spezifikation gibt dieser Rolle den Park, die Plattformeinstellungen und die Operatorrollen. Jede Zahl nennt ihr Feld in GET /api/v1/admin/cabinet. Die Wahl einer Maschine lässt die anderen Abschnitte unverändert.",
    banner: "Plattformadministrator. Nur im internen Netz.",
    network: "Internes Netz",
    rangesNote: "Das sind die DUS1-Netze, die diese Installation bereits verwendet. Eine weitergeleitete Adresse zählt nur, wenn die Verbindung selbst vom Cluster-Proxy kommt.",
    park: "Park",
    fleet: "Flotte",
    organization: "Organisation",
    task: "Aufgabe",
    environment: "Umgebung",
    machine: "Maschine",
    sourceCabinet: "GET /api/v1/admin/cabinet",
    sourceTenants: "counts.tenants",
    sourceTasks: "counts.tasks",
    sourceUsers: "counts.users",
    sourceMachines: "machines",
    installedMemory: "Eingebauter Speicher",
    installedStorage: "Eingebauter Speicherplatz",
    fieldNull: "{field} ist in dieser Antwort null.",
    missingField: "Kein Messwert. Diese Antwort hat kein {field}.",
    notASeries: "Das ist eine Zahl, keine Messreihe.",
    loadChart: "Auslastung",
    memoryUsedChart: "Speicher belegt",
    memoryFreeChart: "Speicher frei",
    fieldLoad: "machines[].load",
    fieldMemoryUsed: "machines[].memory_used_bytes",
    fieldMemoryFree: "machines[].memory_free_bytes",
    fieldDiskFree: "machines[].disk_free_bytes",
    fieldCpu: "machines[].cpu_count",
    alsoMissing: "In dieser Maschine ebenfalls nicht vorhanden",
    usersNote: "counts.users ist die Zahl der Benutzer. Das ist nicht die Zahl der Organisationen.",
    counts: "counts",
    audit: "Audit",
    clients: "Kunden",
    macs: "Macs",
    journal: "Journal",
    requests: "Anfragen",
    sourceAudit: "GET /api/v1/audit",
    sourceRequests: "GET /api/v1/operator/workspace-requests?limit=50",
    journalEmpty: "Diese Route hat keine Ereignisse zurückgegeben.",
    journalNote: "Diese Route gibt die Ereignisse der angemeldeten Organisation zurück.",
    requestsEmpty: "Diese Route hat keine Anfragen zurückgegeben.",
    clientsListNote: "tenant_name in dieser Liste stammt aus den Arbeitsbereich-Anfragen dieser Antwort. Das ist nicht counts.tenants.",
    noMachines: "Kein Live-Mac ist erfasst.",
    reviewLead: "Die Prüfung nutzt die bestehende Operator-Warteschlange. Eine Prüfung weist keinen Mac zu.",
    enrollTitle: "Mac erfassen",
    enrollLead: "Legt einen Live-Eintrag in Wartung und ein einmaliges Connector-Token an. Der Mac wird keinem Kunden zugewiesen und ist nicht mietbar.",
    enrollName: "Name",
    serial: "Seriennummer",
    enrollPurpose: "Zweck",
    purposeTest: "Dedizierter Test",
    purposeRental: "Mietbestand",
    enrollSubmit: "Erfassen",
    enrollFailed: "Der Mac konnte nicht erfasst werden",
    tokenOnce: "Einmal sichtbar.",
    notConnectedTitle: "Nicht verbunden",
    notConnectedLead: "Diese Aktionen bleiben sichtbar, damit sie nicht für funktionierende Steuerungen gehalten werden. Hier wird kein Dienst aufgerufen.",
    notConnected: "Nicht verbunden",
    save: "Sichern",
    restore: "Wiederherstellen",
    export: "Export",
    delete: "Löschen",
    payment: "Zahlung",
    icloud: "iCloud",
    assignment: "Mac-Zuweisung",
    mail: "E-Mail",
    push: "Push",
    roles: "Operatorrollen",
    settings: "Plattformeinstellungen",
    refusedTitle: "Nur im internen Netz",
    refusedBody: "Diese Seite ist nur im internen Netz erreichbar.",
  },
  operatorWorkspace: {
    title: "Arbeitsbereich-Anfragen",
    lead: "Kunden-Arbeitsbereich-Anfragen prüfen. Ihre Notizen sind für Kunden sichtbar. Eine Freigabe provisioniert keinen Mac.",
    bounds: "Keine Infrastrukturadressen, Preise oder SSH-Steuerung auf diesem Bildschirm.",
    queueTitle: "Warteschlange Arbeitsbereich-Anfragen",
    queueLead: "Gespeicherte Kundenanfragen zur Operator-Prüfung — keine Erfüllung.",
    openQueue: "Anfrage-Warteschlange öffnen",
    stateFilter: "Status",
    stateAll: "Alle Status",
    empty: "Keine Anfragen",
    emptyBody: "Keine Arbeitsbereich-Anfragen passen zu diesem Filter.",
    markReviewing: "In Prüfung setzen",
    decline: "Ablehnen",
    reviewTitle: "Als in Prüfung markieren",
    declineTitle: "Anfrage ablehnen",
    reviewConfirm: "Prüfung speichern",
    declineConfirm: "Anfrage ablehnen",
    reviewNote: "Kundensichtbare Notiz",
    noteRequired: "Notiz eingeben (1–2000 Zeichen)",
    actionState: "Nächster Status",
    customerVisibleNote:
      "Diese Notiz ist für Kunden sichtbar. Keine Infrastrukturdetails, Zugangsdaten oder nur interne Hinweise.",
    conflict:
      "Diese Anfrage hat sich geändert oder der Übergang ist ungültig. Warteschlange neu geladen — erneut versuchen.",
    actionFailed: "Anfrage konnte nicht aktualisiert werden",
  },
  status: {
    discovered: "entdeckt",
    verifying: "Prüfung",
    available: "verfügbar",
    reserved: "reserviert",
    preparing: "Vorbereitung",
    leased: "vermietet",
    reclaiming: "Rücknahme",
    sanitizing: "Bereinigung",
    quarantined: "Quarantäne",
    maintenance: "Wartung",
    retired: "außer Betrieb",
    requested: "angefordert",
    provisioning: "Bereitstellung",
    active: "aktiv",
    ending: "Beendigung",
    ended: "beendet",
    rejected: "abgelehnt",
    failed: "fehlgeschlagen",
    canceled: "abgebrochen",
    queued: "in Warteschlange",
    dispatched: "zugewiesen",
    running: "läuft",
    succeeded: "erfolgreich",
    cancel_requested: "Abbruch angefordert",
    accepted: "angenommen",
    reconciling: "Abgleich",
    healthy: "gesund",
    degraded: "eingeschränkt",
    stale: "veraltet",
    pending: "ausstehend",
    unavailable: "nicht verfügbar",
    offline: "offline",
    unknown: "unbekannt",
    plan: "Plan",
    diagnostics: "Diagnose",
    demo: "Demo",
    live: "Live",
    pilot: "Pilot",
    openai: "OpenAI",
    anthropic: "Anthropic",
    xai: "xAI / Grok",
    google: "Google Gemini",
    github: "GitHub",
    gitlab: "GitLab.com",
    stored: "gespeichert",
    verified: "geprüft",
    error: "Fehler",
    not_checked: "nicht geprüft",
    interactive: "Interaktiver Mac-Arbeitsbereich",
    "ios-build": "iOS-Build-Runner",
    "agent-workspace": "KI-Agent-Arbeitsbereich",
    request_only: "nur Anfrage",
    "remote-desktop": "Remote-Desktop",
    ssh: "SSH",
    git: "Git",
    xcode: "Xcode",
    "gitlab-runner": "GitLab-Runner",
    "artifact-export": "Artefakt-Export",
    "project-scoped-credentials": "Projektbezogene Zugangsdaten",
    "bounded-agent-runner": "Begrenzter Agent-Runner",
    reviewing: "in Prüfung",
    declined: "abgelehnt",
    "lease.create": "Miete erstellen",
    "lease.end": "Miete beenden",
    "task.create": "Aufgabe erstellen",
    "task.cancel": "Aufgabe abbrechen",
    "planning-only": "nur Planung",
    not_started: "nicht gestartet",
    reserve_exclusively: "Exklusiv reservieren",
    create_standard_account: "Standardkonto anlegen",
    apply_profile: "Profil anwenden",
    attach_scoped_resources: "Eingeschränkte Ressourcen anbinden",
    verify_isolation: "Isolation prüfen",
    issue_access: "Zugang ausstellen",
    activate_lease: "Miete aktivieren",
    dedicated_mac_not_qualified: "Dedizierter Mac nicht qualifiziert",
    enrollment_and_recovery_not_qualified: "Enrollment und Recovery nicht qualifiziert",
    provisioning_adapter_not_enabled: "Bereitstellungs-Adapter nicht aktiviert",
    isolation_not_qualified: "Isolation nicht qualifiziert",
  },
  environmentSave: {
    bannerMark: "Vorschau.",
    banner: "Synthetisches Beispiel. Speichern, Wiederherstellen, Export und Löschen sind nicht verbunden.",
    lead: "Liste, Bühne und Manifest bleiben zum Vergleich. Brief, Linie und Plakat bleiben Entwürfe. Register ist das Kabinett der Umgebung.",
    back: "Zurück zur Umgebung",
    variantLabel: "Layout",
    phaseLabel: "Beispielzustand",
    railNote: "Nur Vorschaurahmen. Der übrige Kabinettbereich wird hier nicht geöffnet.",
    kicker: "Kein aktiver Arbeitsbereich",
    notConnected: "Nicht verbunden. Diese Steuerelemente rufen den Dienst nicht auf.",
    variants: {
      ledger: {
        name: "Liste",
        blurb: "Datierte Beispiel-Wiederherstellungspunkte, dann Aufbewahrung und Kontingent, dann Aktionen.",
      },
      stage: {
        name: "Bühne",
        blurb: "Ein Beispielzustand füllt die Seite. Fakten stehen daneben. Die Historie ist nicht das Thema.",
      },
      manifest: {
        name: "Manifest",
        blurb: "Enthalten, ausgeschlossen, nur in der Cloud und nicht wiederherstellbar bleiben getrennte Gruppen.",
      },
      letter: {
        name: "Brief",
        blurb: "Vier Randhandlungen teilen die Grundlinie mit vier Absätzen: Zustand, Umfang, Nachweis, Frist.",
      },
      rule: {
        name: "Linie",
        blurb: "Fünf gleiche Stationen auf einer Linie. Der Zustand ist das leichte Wort darüber.",
      },
      index: {
        name: "Register",
        blurb: "Überschriebene Gruppen an einer rechten Kante. Eine lange Folge steht unter ihrer Zeile.",
      },
      poster: {
        name: "Plakat",
        blurb: "Ein Wort, eine Zeile darunter, dann vier Handlungen auf einer gemeinsamen Grundlinie.",
      },
    },
    studies: {
      earlier: "Behalten",
      newer: "Neue Entwürfe",
      notFiled: "nicht verbunden",
      letterMark: "Rand. Diese Wörter rufen den Dienst nicht auf.",
      letterDate: "24. Oktober 2026 · UTC",
      letterMoments:
        "Zwei Beispielzeitpunkte werden nur erwähnt: 18. Oktober 09:40 UTC und 22. Oktober 16:05 UTC. Keiner ist ein gespeichertes Objekt.",
      letterScopeTitle: "Umfang",
      letterRecordTitle: "Nachweis",
      letterTermTitle: "Frist",
      letterScope:
        "Eine Speicherung würde lokale Dateien, Projektdaten und ein Manifest der Werkzeuge und Versionen enthalten. Caches, die neu aufgebaut werden können, bleiben draußen. iCloud-Platzhalter liegen nur in der Cloud und gelten nicht als kopiert. Schlüsselbund, Apple-Sitzungen und ein startfähiges Abbild des Mac würden nicht wiederhergestellt.",
      letterRecord:
        "Zwei Zeitpunkte sind nur Beispiele: 18. Oktober 2026, 09:40 UTC, und 22. Oktober 2026, 16:05 UTC. Keiner ist ein gespeichertes Objekt. Es gibt keine geprüfte Speicherung, und die Größe ist unbekannt. Das Beispielprofil workspace-files-v1 ist kein geprüftes Wiederherstellungsziel.",
      letterTerm:
        "Die Regel, kein Live-Zähler, behält ein geprüftes finales Archiv drei Kalendermonate in UTC. Der Preis einer Verlängerung ist offen. Kontingent, Zahlung und die iCloud-Anmeldung sind nicht verbunden. Löschen würde eine ausdrückliche Bestätigung brauchen und ist nicht verbunden. Ein übertragbares startfähiges Mac-Abbild wird nicht versprochen.",
      ruleFoot:
        "Auf dieser Linie wird nichts gespeichert, wiederhergestellt, exportiert oder gelöscht. Es wird kein Mac zugewiesen, nicht bezahlt und nicht bei iCloud angemeldet.",
      ruleHold:
        "Die Beispiele 2026-10-18 09:40 UTC und 2026-10-22 16:05 UTC sind nicht gespeichert. Lokale Dateien und Projektdaten wären enthalten. Caches, iCloud-Platzhalter, Schlüsselbund und ein Startabbild nicht.",
      ruleClosed:
        "Speichern, Wiederherstellen, Export, Löschen, Kontingent, Zahlung, iCloud und die Mac-Zuweisung sind nicht verbunden.",
      indexMoment: "Beispiel. Kein gespeichertes Objekt.",
      indexRetention: "Drei Monate nach einem geprüften finalen Archiv. Preis offen. Zahlung nicht verbunden.",
      indexIcloud: "Nicht angemeldet. Kein Plattform-Backup.",
      indexDelete: "Nicht verbunden. Eine ausdrückliche Bestätigung wäre nötig.",
      indexImage: "Startfähiges Abbild",
      indexOrder: "Reihenfolge",
      indexOrderValue: "Anhalten, Export, Prüfung",
      indexOrderGloss: "Beispielreihenfolge. Es läuft nichts.",
      indexNow: "Jetzt",
      indexMoments: "Zeitpunkte",
      indexScope: "Umfang",
      indexTerm: "Frist",
      indexClosed: "Nicht verbunden",
      indexClosedNote: "Keiner davon ruft den Dienst auf.",
      indexQuotaValue: "Keine Zahl",
      indexPayValue: "Keine Abbuchung",
      indexSaveValue: "Keine Freigabe",
      indexRestoreValue: "Keine Wiederherstellung",
      indexExportValue: "Keine Datei",
      indexDeleteValue: "Bräuchte Bestätigung",
      indexMac: "Mac",
      indexMacValue: "Nicht zugewiesen",
      indexMacLive: "Nicht bereit",
      indexMacLiveGloss: "Laufende Ausführung wird gemeldet. Wiederherstellen ist nicht verbunden.",
      indexMacDemo: "{n} Demo",
      indexMacDemoGloss: "Demo-Mieteinträge sind kein Wiederherstellungs-Mac.",
      indexChecks: "Prüfungen",
      indexChecksValue: "Ausstehend",
      indexChecksIdle: "Läuft nicht",
      indexStateOff: "Laufende Ausführung ist in dieser Kontomeldung aus.",
      indexStateOn: "Laufende Ausführung wird gemeldet. Eine geprüfte Speicherung fehlt weiter.",
      indexArchiveRequests: "Archivanfragen",
      indexOpenCount: "{n} offen",
      indexArchiveGloss: "Eine Kapazitätsanfrage ist keine Speicherung und kein Export.",
      indexExpiry: "Ablauf",
      indexExpiryValue: "Kein Datum",
      indexExpiryGloss: "Diese Antwort hat keine geprüfte Archivzeit, daher wird kein Ablauf berechnet.",
      indexPayFlag: "Nur Flag",
      indexPayFlagGloss: "Checkout wird gemeldet. Diese Seite hat keine Zahlung.",
      indexSaveReported: "Speicherzuweisung wird gemeldet. Speichern und freigeben ist weiter nicht verbunden.",
      indexSample: "Beispiel",
      indexNone: "Keine",
      indexNotChecked: "Nicht geprüft",
      indexIncludedValue: "Lokale Dateien, Projektdaten",
      indexExcludedValue: "Neu aufbaubare Caches",
      indexCloudValue: "iCloud-Platzhalter",
      indexLostValue: "Schlüsselbund, Startabbild",
      indexMonths: "3 Monate UTC",
      indexPrice: "Verlängerung",
      indexPriceValue: "Offen",
      indexPayment: "Zahlung",
      indexNotSignedIn: "Nicht angemeldet",
      indexNotPromised: "Nicht versprochen",
      indexState: {
        running: "Keine geprüfte Speicherung",
        saving: "Nichts geprüft",
        archived: "Nichts freigegeben",
        restoring: "Kein Zugang",
        attention: "Bereinigung blockiert",
      },
      posterVoid: "Nicht verbunden",
      posterFoot:
        "Kontingent unbekannt. Zahlung nicht verbunden. iCloud nicht angemeldet. Kein Mac zugewiesen. Ein startfähiges Abbild wird nicht versprochen.",
      posterScope:
        "Lokale Dateien und Projektdaten wären im Umfang. Caches, iCloud-Platzhalter, Schlüsselbund und ein Startabbild kämen nicht zurück.",
      posterSample: "Beispiel, nicht gespeichert",
      posterTerm: "3 Monate UTC · Preis offen",
      posterClosed: "Kontingent, Zahlung, iCloud, Mac",
    },
    phases: {
      running: {
        name: "In Betrieb",
        body: "Beispiel: die Arbeit kann weitergehen. Es gibt keine geprüfte Speicherung.",
      },
      saving: {
        name: "Speichern",
        body: "Beispiel läuft. Nichts ist geprüft.",
      },
      archived: {
        name: "Archiviert",
        body: "Beispielzustand archiviert. Nichts wurde freigegeben.",
      },
      restoring: {
        name: "Wiederherstellen",
        body: "Beispielwiederherstellung. Zugang wird nicht erteilt.",
      },
      attention: {
        name: "Aufmerksamkeit",
        body: "Beispiel: die Speicherung wurde nicht geprüft. Die Bereinigung bleibt blockiert. Das ist kein echter Fehler.",
      },
    },
    lastSaveTitle: "Letzte geprüfte Speicherung",
    lastSaveNone: "Keine. Es ist kein geprüftes Archiv verbunden.",
    sizeTitle: "Größe",
    sizeUnknown: "Unbekannt",
    retentionTitle: "Aufbewahrung",
    retentionBody:
      "Regel, kein Live-Zähler: drei Kalendermonate in UTC nach Prüfung eines finalen Archivs. Der Preis für eine Verlängerung ist nicht festgelegt. Zahlung ist nicht verbunden.",
    quotaTitle: "Kontingent",
    quotaBody: "Nicht verbunden. Es wird keine Kontingentzahl gezeigt.",
    compatibilityTitle: "Kompatibilität",
    compatibilityBody: "Beispielprofil workspace-files-v1. Kein geprüftes Wiederherstellungsziel.",
    icloudTitle: "iCloud",
    icloudBody:
      "Freiwillig und extern. Kein Plattform-Backup. Anmeldung ist nicht verbunden. Nur in der Cloud liegende Dateien gelten nicht als kopiert.",
    macReady: "Ein Mac ist nicht bereit, solange Speichern, Wiederherstellen oder Prüfungen nicht abgeschlossen sind.",
    progressSteps: "Nur Beispielreihenfolge: anhalten, exportieren, prüfen. Es wird kein Prozent gemessen.",
    pointsTitle: "Wiederherstellungspunkte",
    pointSample: "Beispielzeile",
    pointUnverified: "Kein gespeichertes Objekt",
    included: "Enthalten",
    excluded: "Ausgeschlossen",
    cloudOnly: "Nur Cloud",
    nonRestorable: "Nicht wiederherstellbar",
    includedItems: ["Lokale Dateien", "Projektdaten", "Manifest der Werkzeuge und Versionen"],
    excludedItems: ["Caches, die neu aufgebaut werden können"],
    cloudItems: ["iCloud-Platzhalter"],
    nonRestorableItems: ["Schlüsselbund und Apple-Sitzungen", "Ein startfähiges Abbild des ganzen Mac"],
    saveRelease: "Speichern und freigeben",
    restore: "Auf einem Mac wiederherstellen",
    exportAction: "Exportieren",
    deleteAction: "Löschen",
    deleteConsequence:
      "Löschen würde ein geprüftes Archiv nur nach ausdrücklicher Bestätigung entfernen. Dieser Vorgang ist nicht verbunden.",
    bootNote: "Ein übertragbares startfähiges Mac-Abbild wird nicht versprochen.",
  },
  demo: { chip: "DEMO", liveChip: "LIVE" },
};
